import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';

import './sticky-tray.scss';

function StickyTrayUI({ isSticky, children, portalId = 'sticky-tray-portal' }) {
  const [stickyTrayPortal, setStickyTrayPortal] = useState(document.getElementById(portalId));

  useEffect(() => {
    if (stickyTrayPortal) {
      return;
    }

    const portal = document.createElement('div');
    portal.classList.add('standalone-banner');
    portal.setAttribute('style', 'position: fixed; right: 0; bottom: 0; left: 0; z-index: 1030');
    portal.setAttribute('id', portalId);
    document.body.appendChild(portal);

    // Intentional state update after creating the portal DOM node.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setStickyTrayPortal(portal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stickyTray = (
    <div
      className={classnames('sticky-tray', {
        'is-sticky': isSticky,
      })}
    >
      {children}
    </div>
  );

  return isSticky && stickyTrayPortal ? createPortal(stickyTray, stickyTrayPortal) : null;
}

StickyTrayUI.propTypes = {
  isSticky: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  portalId: PropTypes.string,
};

export function StickyTray({ showTimeout = 100, ...props }) {
  // Need to wait till adhesion shows
  // Can be used to adjust tray components order by changing timeout
  return (
    <ClientSideRender showTimeout={showTimeout}>
      <StickyTrayUI {...props} />
    </ClientSideRender>
  );
}
